import { Link } from "react-router-dom";

const domains = [
  { icon: "ri-brain-line", label: "AI & Machine Learning" },
  { icon: "ri-sparkling-line", label: "Generative AI & Prompt Engineering" },
  { icon: "ri-robot-2-line", label: "Agentic AI & Automation" },
  { icon: "ri-shield-keyhole-line", label: "Cybersecurity" },
  { icon: "ri-cloud-line", label: "Cloud Computing" },
  { icon: "ri-bar-chart-2-line", label: "Data Analytics" },
];

export default function AcademySection() {
  return (
    <section className="py-20 bg-slate-50" id="academy">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-flex items-center gap-2 border border-slate-200 rounded-full px-4 py-1.5 mb-5">
              <i className="ri-graduation-cap-line text-[#9bc400] text-xs" />
              <span className="text-slate-500 text-xs font-semibold uppercase tracking-wider">CPI Academy</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-black text-slate-900 mb-4 leading-tight">
              Certify Your Team.<br />
              <span style={{color: "#9bc400"}}>Lead the AI Era.</span>
            </h2>
            <p className="text-slate-500 text-base leading-relaxed mb-6">
              Through our exclusive partnership with <strong className="text-slate-700">i3Cert</strong>, the Global Certification Partner for Sub-Saharan Africa, we deliver globally recognized, vendor-aligned AI and technology certifications.
            </p>
            <div className="grid grid-cols-2 gap-2 mb-8">
              {domains.map((d) => (
                <div key={d.label} className="flex items-center gap-2.5 bg-white border border-slate-100 rounded-lg px-3 py-2.5">
                  <i className={`${d.icon} text-[#9bc400] text-sm flex-shrink-0`} />
                  <span className="text-xs font-semibold text-slate-700 leading-tight">{d.label}</span>
                </div>
              ))}
            </div>
            <div className="flex flex-col sm:flex-row gap-3">
              <Link to="/academy" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg bg-black text-[#C8F135] font-semibold text-sm whitespace-nowrap cursor-pointer hover:bg-zinc-800 transition-colors">
                Browse Courses <i className="ri-arrow-right-line" />
              </Link>
              <Link to="/contact" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg border border-slate-200 text-slate-700 font-semibold text-sm whitespace-nowrap cursor-pointer hover:border-slate-400 transition-colors">
                Corporate Training
              </Link>
            </div>
          </div>

          <div>
            <div className="relative rounded-2xl overflow-hidden w-full h-72 mb-5">
              <img
                src="https://readdy.ai/api/search-image?query=diverse%20professionals%20in%20modern%20training%20classroom%20learning%20AI%20technology%20certification%20program%20instructor%20led%20workshop%20Chicago%20corporate%20upskilling%20warm%20professional%20atmosphere%20wide&width=720&height=400&seq=academy2026&orientation=landscape"
                alt="CPI Academy AI training"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
              <div className="absolute top-4 right-4 bg-[#C8F135] rounded-xl px-4 py-2 text-center">
                <div className="text-black text-xs font-black">i3Cert</div>
                <div className="text-black text-xs">Certified</div>
              </div>
              <div className="absolute bottom-4 left-4 flex gap-2">
                {["Instructor-Led", "Self-Paced", "Bootcamps"].map((mode) => (
                  <span key={mode} className="bg-white/15 backdrop-blur-sm border border-white/20 text-white text-xs font-medium px-2.5 py-1 rounded-full">{mode}</span>
                ))}
              </div>
            </div>
            <div className="grid grid-cols-3 gap-4 bg-white border border-slate-100 rounded-xl p-5">
              {[{ value: "1,200+", label: "Trained" }, { value: "8", label: "Domains" }, { value: "Global", label: "i3Cert" }].map((s) => (
                <div key={s.label} className="text-center">
                  <div className="text-xl font-black text-slate-900">{s.value}</div>
                  <div className="text-xs text-slate-500 mt-0.5">{s.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
